import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { api_url_v1 } from '../utils/config';

const API_URL = api_url_v1;

// 🟢 Add Blog
export const addBlog = createAsyncThunk(
  'blogs/addBlog',
  async (blogData, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${API_URL}/addBlog`, blogData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔵 Fetch All Blogs (FIXED - now uses axios for consistency)
export const fetchBlogs = createAsyncThunk(
  'blogs/fetchBlogs',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/getBlogs`, {
        params: {
          _cb: Date.now(), // cache buster
        },
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


// 🟣 Get Single Blog
export const getSingleBlog = createAsyncThunk(
  'blogs/getSingleBlog',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${API_URL}/getSingleBlog`, { id });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🟠 Edit Blog (FIXED - corrected axios.put syntax)
export const editBlog = createAsyncThunk(
  'blogs/editBlog',
  async ({ id, blogData }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${API_URL}/editBlog`, { blogid:id, ...blogData });
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔴 Delete Blog (FIXED - corrected axios.delete syntax)
export const deleteBlog = createAsyncThunk(
  'blogs/deleteBlog',
  async ({id}, { rejectWithValue }) => {
    try {
      const res = await axios.delete(`${API_URL}/deleteBlog`, { 
        data: { blogid: id } 
      });
      return { id, message: res.data?.message || 'Blog deleted successfully' };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// export const deleteBlog = createAsyncThunk(
//   'blogs/deleteBlog',
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await fetch(`${api_url_v1}/deleteBlog`, {
//         method: 'DELETE',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${localStorage.getItem('adminToken')}`,
//         },
//         body: JSON.stringify({ blogid: id }),

//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         return rejectWithValue(errorData.message || 'Failed to delete blog');
//       }

//   return { id, message: 'Blog deleted successfully' };
// } catch (error) {
//       return rejectWithValue(error.message || 'Network error');
//     }
//   }
// );
// export const deleteBlog = createAsyncThunk(
//   'blogs/deleteBlog',
//   async (id, { rejectWithValue }) => {
//     try {
//       const res = await axios({
//         method: "delete",
//         url: `${API_URL}/deleteBlog`,
//         data: { blogid: id },
//         headers: {
//           "Content-Type": "application/json"
//         }
//       });

//       return {
//         id,
//         message: res.data?.message || "Blog deleted successfully"
//       };

//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );


// 🧩 Slice
const blogSlice = createSlice({
  name: 'blogs',
  initialState: {
    blogs: [],
    singleBlog: null,
    loading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearBlogState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Add Blog
      .addCase(addBlog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addBlog.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs.unshift(action.payload.blog || action.payload?.data);
        state.success = 'Blog added successfully';
      })
      .addCase(addBlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch All Blogs (FIXED - added missing cases)
      .addCase(fetchBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = action.payload.blogs?.data || action.payload?.data;
        state.success = 'Blogs fetched successfully';
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Single Blog
      .addCase(getSingleBlog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleBlog.fulfilled, (state, action) => {
        state.loading = false;
        state.singleBlog = action.payload.blog || action.payload?.data;
      })
      .addCase(getSingleBlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Edit Blog
      .addCase(editBlog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editBlog.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload.blog || action.payload;
        console.log(updated)
        state.blogs = state.blogs.map((b) =>
          b.id === updated.id ? updated : b
        );
        state.success = 'Blog updated successfully';
      })
      .addCase(editBlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete Blog
      .addCase(deleteBlog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBlog.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = state.blogs.filter((b) => b.id !== action.payload.id);
        state.success = action.payload.message;
      })
      .addCase(deleteBlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBlogState } = blogSlice.actions;
export default blogSlice.reducer;